/**
 * ⭐ WHO PAYS, IN HELEN'S WORDS - one table for every kiosk screen that names a
 * payer kind. Moved here from `screens/admin/PortalRequests.tsx` at board 2764 M7
 * so the Invoices tab labels each invoice of a nursing home's pair ("HSE / Rehab",
 * "House account") with the SAME words the Requests tab uses for the request
 * behind it.
 *
 * ⛔ THE KEYS ARE THE UPSTREAM ENUM, VERBATIM. `CREATE TYPE portal.payer_kind
 * AS ENUM ('hse','house','self')` (portal migrations), and the labels are the
 * portal's own (`copy.ts` payerLabels) so the two surfaces call the same thing
 * the same name. `hse` and `house` are also the kiosk's own
 * `bookings.payer_kind` / `account_invoices.payer_kind` tokens (v44).
 *
 * ⚠️ An earlier version invented `home`/`family`/`resident`. Not one key
 * matched, so every row fell through to the raw token and Helen read `hse` in
 * the who-pays column - and the spec passed, because its fixture ALSO said
 * `home`. The durable guards are `test/core/payer-vocabulary-parity.spec.ts`
 * (this table against the portal's, both directions, plus a literal content
 * pin; it reads THIS FILE's source text) and the Requests spec arm that renders
 * every real enum value and asserts no raw token reaches the operator.
 */
export const PAYER_WORDS: Record<string, string> = {
  hse: 'HSE / Rehab',
  house: 'House account',
  self: 'Cash / card',
};
